import React, { useState, useEffect } from "react"
import { Button } from "react-bootstrap"
import { FormattedMessage } from "react-intl"

import PageLoadingPanel from "../../../shared_components/widgets/PageLoadingPanel"
import PageErrorPanel from "../../../shared_components/widgets/PageErrorPanel"
import { LanzaTable } from "../../../shared_components/widgets/LanzaTable"
import { API_STATUS } from "../../../shared_components/widgets/utils"
import { logToServer } from "../../../ErrorBoundary"
import { LocaleFormattedDate } from "../../internationalization/LocaleFormatted"
import { addNewObject, getObjectsList } from "../../../Loaders"
import { PageTitle } from "../../../config/AppSettingsConfigProvider"
import ModalBackupView from "./ModalBackupView"

export default function DatabaseBackupTable({ intl }) {
  const [statusDataLoad, setStatusDataLoad] = useState(API_STATUS.LOADING)
  const [statusNewCreate, setStatusNewCreate] = useState(null)
  const [errMsg, setErrMsg] = useState(null)
  const [currBackupID, setCurrBackupID] = useState(null)
  const [viewLogsModal, setViewLogsModal] = useState(false)
  const [data, setData] = useState([])

  const getData = () => {
    setStatusDataLoad(API_STATUS.LOADING)
    setErrMsg(null)

    getObjectsList("/administration/api/database-backup/")
      .then((d) => {
        setStatusDataLoad(API_STATUS.SUCCESS)
        setData(d)
      })
      .catch((error) => {
        console.error(error)
        logToServer(error)
        setStatusDataLoad(API_STATUS.ERROR)
        setErrMsg(error)
      })
  }
  useEffect(() => {
    getData()
  }, [])

  const createBackup = (event) => {
    event.preventDefault()

    if (
      !confirm(
        intl.formatMessage({
          id: `administration.database-backup.are-you-sure-create-backup`,
        }),
      )
    ) {
      return
    }

    setStatusNewCreate(API_STATUS.LOADING)
    addNewObject("/administration/api/database-backup/create_backup/", {})
      .then((_) => {
        setStatusNewCreate(API_STATUS.SUCCESS)
        alert(
          intl.formatMessage({
            id: "administration.database-backup.backup-successful",
          }),
        )
        getData()
      })
      .catch((error) => {
        console.error(error)
        logToServer(error)
        setStatusNewCreate(API_STATUS.ERROR)
        alert(
          intl.formatMessage(
            {
              id: "administration.database-backup.backup-error",
            },
            { err_message: error },
          ),
        )
      })
  }

  const CreateBackupButton = ({}) => {
    return (
      <Button variant={"outline-primary"} onClick={createBackup}>
        <span className={"fa fa-wrench"} />
        &nbsp;&nbsp;
        <FormattedMessage id={"administration.database-backup.create-backup"} />
      </Button>
    )
  }

  return (
    <div className={"content-block full-height-min"}>
      <PageTitle glyph={"tasks"} id={"administration.database-backup"} description={"Database Backup"} />
      <hr />
      {statusDataLoad === API_STATUS.LOADING ? (
        <PageLoadingPanel />
      ) : statusDataLoad === API_STATUS.ERROR ? (
        <PageErrorPanel errorMessage={errMsg} attemptReload={getData} />
      ) : (
        statusDataLoad === API_STATUS.SUCCESS &&
        ((data || []).length ? (
          <div>
            <div align={"right"} style={{ marginBottom: "20px" }}>
              <Button variant={"outline-primary"} onClick={getData}>
                <span className={"fa fa-refresh"} />
                &nbsp;
                <FormattedMessage id={"general.refresh"} />
              </Button>
              &nbsp;
              {statusNewCreate === API_STATUS.LOADING ? (
                <span>
                  <div className="spinner-border text-primary text-center" role="status" />
                  &nbsp;
                  <FormattedMessage id={"administration.database-backup.creating-backup"} />
                  ...
                </span>
              ) : (
                <CreateBackupButton />
              )}
            </div>
            <LanzaTable
              className={"table table-bordered tbl_lanzatable table-hover"}
              columns={[
                {
                  Header: <FormattedMessage id={"general.date"} />,
                  accessor: "date",
                  Cell: ({ value }) => <LocaleFormattedDate date={value} shouldParse={true} />,
                },
                {
                  Header: <FormattedMessage id={"general.name"} />,
                  accessor: "name",
                },
                {
                  Header: <FormattedMessage id={"general.size"} />,
                  className: "text-center",
                  accessor: "size_bytes",
                  Cell: ({ value }) => (value / (1024 * 1024)).toFixed(2) + " MB",
                  disableFilters: true,
                },
                {
                  Header: "",
                  id: "actions",
                  className: "text-center",
                  accessor: (backup) => {
                    return (
                      <>
                        <Button
                          variant={"outline-primary"}
                          size={"sm"}
                          onClick={(event) => {
                            setCurrBackupID(backup.id)
                            setViewLogsModal(true)
                          }}
                        >
                          <span className={"fa fa-bars"} />
                          &nbsp;&nbsp;
                          <FormattedMessage id={"general.view"} description={"View"} />
                        </Button>
                      </>
                    )
                  },
                  disableSortBy: true,
                  disableFilters: true,
                },
              ]}
              data={data}
              allowSorting={true}
              allowFilters={true}
              allowGlobalFilter={false}
              allowRowSelection={false}
              initialTableOptions={{
                sortBy: [{ id: "date", desc: true }],
                pageSize: 20,
              }}
            />

            {/*---------- Modal ----------*/}
            {currBackupID && viewLogsModal && (
              <ModalBackupView
                backup_id={currBackupID}
                show={viewLogsModal}
                onHide={() => {
                  setCurrBackupID(null)
                  setViewLogsModal(false)
                }}
              />
            )}
            {/*---------- Modal ----------*/}
          </div>
        ) : (
          <div className={"center_middle"} style={{ height: "200px" }}>
            <div align={"center"}>
              <i className={"fa fa-info-circle"} style={{ fontSize: "60px" }} />
              <h4>
                <FormattedMessage id={"administration.database-backup.no-backups-found"} />
                <div style={{ marginTop: "20px" }}>
                  <CreateBackupButton />
                </div>
              </h4>
            </div>
          </div>
        ))
      )}
    </div>
  )
}
